/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meal_SnackInputs */

const en_meal_snack = /** @type {(inputs: Meal_SnackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snack`)
};

const de_meal_snack = /** @type {(inputs: Meal_SnackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snack`)
};

/**
* | output |
* | --- |
* | "Snack" |
*
* @param {Meal_SnackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const meal_snack = /** @type {((inputs?: Meal_SnackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meal_SnackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_meal_snack(inputs)
	return en_meal_snack(inputs)
});